const _conteststates = [
  {code : 'SCENARIO_WELCOME', order: 1, path: '/scenario-welcome'},
  {code : 'TEST_WELCOME', order: 2, path: '/test-welcome'},
  {code : 'QUESTION', order: 3, path: '/question'},
  {code : 'TEST_EXIT', order: 4, path: '/test-exit'},
  {code : 'REPORT', order: 5, path: '/report'},
  {code : 'SCENARIO_EXIT', order: 6, path: '/scenario-exit'}
]

const _scenariostatuses = [
  {id: 0, color: '#cfd1d6'},
  {id: 1, color: '#b3d8ff'},
  {id: 2, color: '#c2e7b0'},
  {id: 3, color: '#f7d89b'},
  {id: 4, color: '#fdbbbb'}
]

const _scenariosrowclasses = [
  {id: 0, color: 'scenario0'},
  {id: 1, color: 'scenario1'},
  {id: 2, color: 'scenario2'},
  {id: 3, color: 'scenario3'},
  {id: 4, color: 'scenario4'}
]

export default {
    getNextState(state) {
      if(state) {
          let order = state.order;
          order++;
          return this.getStateByOrder(order);
      } else
        return _conteststates[0];
    },
    getStateByOrder(order) {
      if(order) {
        let result = _conteststates.find( a => { return a.order === order; });
        if(result)
          return result;
      }
      return null;
    },
    getStateByCode(code) {
      if(code) {
        let result = _conteststates.find( a => { return a.code === code; });
        if(result)
          return result;
      }
      return null;
    },
    getScenarioStatusColor(id) {
      if(id) {
        let result = _scenariostatuses.find( a => { return a.id === id; });
        if(result)
          return result.color;
      }
      return '#cfd1d6';
    },
    getScenarioStatusClass(id) {
        if (id) {
            let result = _scenariosrowclasses.find(a => { return a.id === id; });
            if (result)
                return result.color;
        }
        return 'scenario0';
    }
}



// WEBPACK FOOTER //
// ./src/api/contest/contest-states.js